interface State {
  invoiceList: any;
  invoiceCount: number;
  invoiceDetails: any;
  invoiceCustomers: any;
}

export const invoiceReducer = (
  state: State = {
    invoiceList: [],
    invoiceCount: 0,
    invoiceDetails: null,
    invoiceCustomers: [],
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_INVOICE_LIST":
      return {
        ...state,
        invoiceList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.invoiceList, ...action.payload?.data],
        invoiceCount: action.payload.count,
      };
    case "GET_INVOICE_DETAILS":
      return {
        ...state,
        invoiceDetails: action.payload,
      };
    case "UPDATE_INVOICE_SEND_STATUS":
      return {
        ...state,
        invoiceList: state.invoiceList.map((invoice: any) =>
          invoice._id === action.payload.id
            ? { ...invoice, is_send: true }
            : invoice,
        ),
        invoiceDetails: state?.invoiceDetails
          ? {
              ...state?.invoiceDetails,
              is_send: true,
            }
          : "",
      };
    case "UPDATE_INVOICE_PAID_STATUS":
      return {
        ...state,
        invoiceList: state.invoiceList.map((invoice: any) =>
          invoice._id === action.payload._id ? action.payload : invoice,
        ),
        invoiceDetails: state?.invoiceDetails ? action.payload : "",
      };
    case "DELETE_INVOICE":
      return {
        ...state,
        invoiceList: state.invoiceList.filter(
          (invoice: any) => invoice._id !== action.payload,
        ),
        invoiceCount: state.invoiceCount > 0 ? state.invoiceCount - 1 : 0,
      };
    case "CLEAR_INVOICE_DETAILS":
      return {
        ...state,
        invoiceDetails: null,
      };
    case "CLEAR_INVOICE_ARRAY":
      return {
        ...state,
        invoiceList: [],
        invoiceCount: 0,
      };
    case "GET_INVOICE_UNIQUE_CUSTOMERS":
      return {
        ...state,
        invoiceCustomers: action.payload,
      };
    default:
      return state;
  }
};
